<globalelem-footnote-reference-component [content]="content" [reference]="reference" [attr.module-id]="moduleId" />
